import './ReviewItem.style.css';
import Star from 'assets/icon/star_icon.png';
import dayjs from 'dayjs';
import { Content, Button } from 'components';
import { Flex } from 'antd';

const ReviewItemDetail = ({
  screenSize,
  data,
  isShowList = false,
  selectedImage,
  onSelectImage = () => {},
  onReviewDetail = () => {},
}) => {
  /* ===== Render ===== */
  return (
    <Content maxWidth="100%" padding="30px 0px">
      <Flex vertical gap={5} align="center">
        <div
          style={{
            display: 'flex',
            gap: 16,
            width: '100%',
            flexDirection: screenSize > 768 ? 'row' : 'column',
          }}
        >
          {/* 이미지 왼쪽 */}
          <div
            style={{
              width: screenSize > 768 ? '40%' : '100%',
            }}
          >
            {selectedImage?.type === 'IMAGE' ? (
              <img
                src={`${selectedImage?.file_url}`}
                alt="선택된 이미지"
                style={{
                  width: '100%',
                  height: screenSize > 768 ? '488px' : '300px',
                  objectFit: 'contain',
                  borderRadius: 8,
                }}
              />
            ) : (
              <video
                src={`${selectedImage?.file_url}`}
                alt="선택된 영상"
                style={{
                  width: '100%',
                  height: screenSize > 768 ? '488px' : '300px',
                  borderRadius: 8,
                  objectFit: 'contain',
                  background: '#000',
                }}
                autoPlay
                muted
                loop
                playsInline
                controls
              />
            )}
            <div
              style={{
                marginTop: 12,
                display: 'flex',
                gap: 8,
                overflowX: 'auto',
              }}
            >
              {data?.review_img?.map((_item, idx) =>
                _item.type === 'IMAGE' ? (
                  <img
                    key={`review_file-${_item.review_file_id}`}
                    src={`${_item.file_url}`}
                    alt={`리뷰 이미지 ${idx}`}
                    style={{
                      width: 60,
                      height: 60,
                      objectFit: 'cover',
                      border:
                        selectedImage?.review_file_id === _item?.review_file_id
                          ? '2px solid #000'
                          : '1px solid #ccc',
                      borderRadius: 4,
                      cursor: 'pointer',
                    }}
                    onClick={() => onSelectImage(_item)}
                  />
                ) : (
                  <video
                    key={`review_file-${_item.review_file_id}`}
                    src={`${_item?.file_url}`}
                    width={60}
                    height={60}
                    muted
                    style={{
                      borderRadius: 4,
                      objectFit: 'cover',
                      border:
                        selectedImage?.review_file_id === _item?.review_file_id
                          ? '2px solid #000'
                          : '1px solid #ccc',
                      cursor: 'pointer',
                    }}
                    onClick={() => onSelectImage(_item)}
                  />
                )
              )}
            </div>
          </div>

          {/* 텍스트 우측 */}
          <div
            style={{
              width: screenSize > 768 ? '60%' : '100%',
            }}
          >
            <div>
              <ul
                style={{
                  display: 'flex',
                  gap: 16,
                }}
              >
                <li>
                  <img
                    src={Star}
                    alt="점수"
                    style={{
                      width: 16,
                      verticalAlign: 'middle',
                    }}
                  />{' '}
                  {parseFloat(data?.review_score).toFixed(1) ?? '0.0'}
                </li>
                {'|'}
                <li>
                  {data?.user_name ? `${data?.user_name[0]}**` : '비회원'}
                </li>
                {'|'}
                <li>{dayjs.unix(data?.created_at).format(`YYYY.MM.DD`)}</li>
              </ul>
            </div>

            <div
              style={{
                marginTop: 12,
                maxHeight: 522,
                overflowY: 'auto',
              }}
            >
              <p>{data?.review_content}</p>
            </div>
          </div>
        </div>
        {isShowList ? (
          <Button onClick={() => onReviewDetail(null)}>목록보기</Button>
        ) : null}
      </Flex>
    </Content>
  );
};

export default ReviewItemDetail;
